<template>
  <a
    :href="lineParams.url"
    :target="lineParams.openInNewTab ? '_blank' : '_self'"
    rel="noopener noreferrer"
    >{{ lineParams.text }}</a
  >
</template>

<script setup lang="ts">
import type { Inline } from '@contentful/rich-text-types'

// Props
const props = defineProps<{
  node: Inline
}>()

const lineParams = {
  url: props.node.data?.target?.fields?.url || '',
  openInNewTab: props.node.data?.target?.fields?.openInNewTab || false,
  text: props.node.data?.target?.fields?.text || '',
}

defineOptions({
  name: 'CMSInlineEntry',
})
</script>
